module.exports = __webpack_public_path__ + "img/step1.a9b20e5c.png";